import React, { useState, useEffect, useRef } from "react";
//import VAD from "@ricky0123/vad-web";
import { FaMicrophoneAlt, FaMicrophoneAltSlash } from "react-icons/fa";
import { askAudioPermissions } from "./audio_utils";

// helper functions
function float32ToInt16(float32Array) {
  const int16Array = new Int16Array(float32Array.length);
  for (let i = 0; i < float32Array.length; i++) {
    int16Array[i] = Math.max(-1, Math.min(1, float32Array[i])) * 0x7fff;
  }
  return int16Array;
}

function arrayBufferToBase64String(buffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)));
}

/**
 * MicVAD-based real-time speech recorder
 * - Filters audio to only send speech chunks
 * - Optimized for real-time AI transcription
 */
const AudioRecorderVAD = ({ selectedMicrophone, audioDataCallback }) => {
  const [isRecording, setIsRecording] = useState(false);
  const vadRef = useRef(null);
  /** 64‑ms silent frame (1024 samples @16 kHz) 
  */
  const ZERO_PAD = useRef(new Int16Array(1024)).current;

  /** how many silent frames we have appended after last speech */
  const silenceTailRef = useRef(0);

  async function initializeVad(){
    try {
        // Dynamically import whichever package you actually installed.
      // Change the name here if you installed the other one.
      const mod = await import("@ricky0123/vad-web");   // or "@ricky0123/vad"

      // The usable class lives in either `mod.default` (ESM) or `mod.MicVAD` (namespace import).
      const MicVAD = mod.default ?? mod.MicVAD ?? mod;  // grab whichever exists

      if (!MicVAD?.new) {
        console.error("MicVAD class not found in the package – check the package name.");
        return;
      }

        console.log("vad ricky 123 initialized ")
        vadRef.current = await MicVAD.new({
          additionalAudioConstraints: selectedMicrophone?.deviceId
            ? { deviceId: { exact: selectedMicrophone.deviceId } }
            : {},
            
          onFrameProcessed: ({ isSpeech }, f32) => {
            
            if (isSpeech > 0.3) { // 0.3 is better than 0.5 especially if environment is noisy
               // console.log("is speech "+isSpeech)
               silenceTailRef.current = 0;
              const int16 = float32ToInt16(f32);
             // const base64 = arrayBufferToBase64String(int16.buffer);
              audioDataCallback(int16.buffer);
             // console.log("vad ricky123 sending data ")
            }
            else if (silenceTailRef.current < 4) {
                silenceTailRef.current += 1;
                // we need to send silence, because if utterances stop abruptly then deepgrams doesn't send back final transcription for last line.
                audioDataCallback(ZERO_PAD.buffer);
              }
          },
        });
      } catch (err) {
        console.log("MicVAD init error:", err);
      }
  }

  useEffect(() => {
    (async () => {
      askAudioPermissions()  
      initializeVad()
    })();

    return () => vadRef.current?.pause();
  }, []);

  const startRecording = async () => {
    try {
      await vadRef.current?.pause() 
      console.log("paused vad ref, restarting...")
      await initializeVad() 
      await vadRef.current?.start();
      setIsRecording(true);
    } catch (err) {
      console.log("Error starting VAD:", err);
    }
  };

  const stopRecording = async () => {
    try {
      await vadRef.current?.pause();
      setIsRecording(false);
        // force‑flush trailing silence
        for (let i = 0; i < 4; i++) audioDataCallback(ZERO_PAD.buffer);
        silenceTailRef.current = 0;
        
    } catch (err) {
      console.log("Error pausing VAD:", err);
    }
  };

  return (
    <div className="mx-auto shadow-md rounded-lg">
      {/* Control Buttons */}
      <div className="flex flex-row space-x-4">
        {!isRecording && (
          <button
            className="flex flex-row items-center justify-center px-10 py-6 bg-purple-500 text-white rounded-lg shadow-md hover:bg-purple-600 focus:outline-none"
            onClick={startRecording}
          >
            <FaMicrophoneAlt className="text-3xl" />
            &nbsp; &nbsp;
            <span>Start Speaking</span>
          </button>
        )}

        {isRecording && (
          <button
            className="flex flex-row items-center justify-center px-10 py-6 bg-red-500 text-white rounded-lg shadow-md hover:bg-red-600 focus:outline-none"
            onClick={stopRecording}
          >
            <FaMicrophoneAltSlash className="text-4xl" />
            &nbsp; &nbsp;
            <span>Mute Microphone</span>
          </button>
        )}
      </div>
    </div>
  );
};

export { AudioRecorderVAD};
